export interface PersonState {
	US: any,
	CA: any,
	MX: any,
}

export interface PersonLov {
	gender: any,
	gender_identity: any,
	salutation_designation: any,
	position_title: any,
	designation: any,
	salutation: any,
	suffix: any,
	religious_order: any,
	marital_status: any,
	cleric_in_book: any,
	state: PersonState
	country: any,
	CoverageSource: any,
	CoverageLevel: any,
}

export interface OrgLov {
	org_category: any,
	org_type: any,
	state: PersonState,
	country: any,
	seasonal_list: any,
	org_close_reason: any,
}

export interface MlpsLov {
	medicalDeclineReason?: any,	
}

export interface ExternalLinks {
	plan_selection_page: string;
	account_page: string;
	person_page: string;
	change_request_page: string;
	groups_page: string;
	change_report_page: string;
	group_page: string;
	billing_history_page: string;
	admin_listing_page: string;
	home_page: string;
	annual_enrollment_admin_page: string;
	enrollment_report: string;
	new_enrollment_form: string;
}

export interface LovProcState {
	personLov: PersonLov;
	orgLov: OrgLov;
	mlpsLov: MlpsLov;
	externalLinks: ExternalLinks;
}

export enum LovProcActionType {
	SET_PERSON_PROC_LOV = 'SET_PERSON_PROC_LOV',
	SET_ORG_PROC_LOV = 'SET_ORG_PROC_LOV',
	SET_MLPS_PROC_LOV = 'SET_MLPS_PROC_LOV',
	SET_EXTERNAL_LINKS = 'SET_EXTERNAL_LINKS',
}